import axios from '../api/axios' 
import { useAuthContext } from '../context/auth' 
import { useLogout } from '../hooks/useLogout'
import jwt_decode from 'jwt-decode'
import { decodeParams } from '../utils/cryptoUtil'

const useRefreshToken = () => {
    const { dispatch } = useAuthContext()
    const { logout } = useLogout()

    const refresh = async () => {
        try {
            const response = await axios.post('/api/auth/refresh') 
            const decodedResponse = decodeParams(response.data.result)
            const decoded = jwt_decode(decodedResponse.accessToken)
            dispatch({type: 'LOGIN', payload: {
                ...decoded.userInfo, 
                accessToken: decodedResponse.accessToken,
                selectableUnits: decodedResponse.selectableUnits,
            }})
            return decodedResponse.accessToken
        } catch (error) {
            // console.log(error)
            const wrongToken = (error.response.status === 403 && error.response.data.error === "Forbidden")
            const userNotFound = error.response.status === 401
            const isBlocked = error.response.status === 400
            if(wrongToken || userNotFound || isBlocked){
                logout()
                return
            }
        }

    }
    return refresh 
} 

export default useRefreshToken 